import React, { useEffect, useState } from "react";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import Activity_item from "../collectrions/Activity_item";
import On_sale from "../collectrions/On_sale";
import Image from "next/image";
import Tokens from "../categories/trending_categories_items";
import Public_Tokens from "../categories/public_trending_categories_items";
import Collections from "../collectrions/collections";
import Explore_collection_item from "../collectrions/explore_collection_item";
import { useWallet } from "@demox-labs/aleo-wallet-adapter-react";
import { useRouter } from "next/router";
import Activity_tab from '../tabs/Activity_tab';
import UserId from 'components/userId';

const tabItemData = [
  {
    id: 1,
    text: "Owned",
    icon: "owned",
  },
  {
    id: 2,
    text: "For Sale",
    icon: "on-sale",
  },
  {
    id: 4,
    text: "Collections",
    icon: "listing",
  },
  {
    id: 5,
    text: "Proofs",
    icon: "puzzle",
  }
];

const tabItemDataDisconnected = [
  {
    id: 2,
    text: "For Sale",
    icon: "on-sale",
  },
  {
    id: 3,
    text: "Owned Publicly",
    icon: "owned",
  },
];
let user_changed_yet = false;


const setItemActiveExt = (val, setItemActive) => {
  setItemActive(val);
}

const User_items = ({ public_key }) => {
  const { publicKey } = useWallet();
  const [itemActive, setItemActive] = useState(1);
  const [tabItem, setTabItem] = useState(tabItemDataDisconnected);

  useEffect(() => {
    if (!publicKey || publicKey !== public_key) {
      setItemActiveExt(2, setItemActive);
      setTabItem(tabItemDataDisconnected);
    }
    else {
      setTabItem(tabItemData);
      window.user_initiated = true;
      if (!user_changed_yet) {
        setItemActiveExt(1, setItemActive);
      }
    }
  }, [publicKey, public_key]);

  return (
    <>
      <section className="relative pt-20 pb-24">
        {/* Display address as beautiful title 
        <div className="container mb-10">
          <div className="flex flex-col items-center justify-center">
            <h3 className="font-display text-3xl font-bold text-jacarta-700 dark:text-white">
              {public_key.slice(0, 6) + "..." + public_key.slice(-4)}
            </h3>
          </div>
        </div>*/}
        <div style={{
          width: "fit-content",
          margin: "auto",
          marginBottom: "2rem",
        }}>
          <UserId
            classes="js-copy-clipboard dark:bg-jacarta-700 border-jacarta-100 hover:bg-jacarta-100 dark:border-jacarta-600 dark:text-jacarta-300 flex w-full select-none items-center rounded-lg border bg-white py-3 px-4"
            userId={public_key || ""}
            cutMiddle={true}
            shortId={true}
          />
        </div>

        <picture className="pointer-events-none absolute inset-0 -z-10 dark:hidden">
          {/* <img src="img/gradient_light.jpg" alt="gradient" className="h-full w-full" /> */}
          <Image
            src="/images/gradient_light.jpg"
            alt="gradient"
            className="h-full w-full"
            layout="fill"
          />
        </picture>
        <div className="container">
          {/* <!-- Tabs Nav --> */}
          <Tabs className="tabs">
            <TabList className="nav nav-tabs scrollbar-custom mb-12 flex items-center justify-start overflow-x-auto overflow-y-hidden border-b border-jacarta-100 pb-px dark:border-jacarta-600 md:justify-center">
              {tabItem.map(({ id, text, icon }) => {
                return (
                  <Tab
                    className="nav-item"
                    role="presentation"
                    key={id}
                    onClick={() => {
                      user_changed_yet = true;
                      return setItemActiveExt(id, setItemActive);
                    }
                    }
                  >
                    <button
                      className={
                        itemActive === id
                          ? "nav-link hover:text-jacarta-700 text-jacarta-400 relative flex items-center whitespace-nowrap py-3 px-6 dark:hover:text-white active"
                          : "nav-link hover:text-jacarta-700 text-jacarta-400 relative flex items-center whitespace-nowrap py-3 px-6 dark:hover:text-white"
                      }
                    >
                      <svg className={"icon mr-1 h-5 w-5 fill-current" + ((icon === "puzzle") ? " h-6 w-6" : "")}>
                        {icon === "pig" ? (
                          <g xmlns="http://www.w3.org/2000/svg" style={{ transform: "scale(0.07)" }}>
                            <g>
                              <g>
                                <path d="M220.976,84.214h-6.054c-6.465-14.758-16.708-27.538-29.988-37.411l8.281-28.347c0.809-2.775-0.023-5.767-2.146-7.725     c-2.128-1.96-5.179-2.551-7.872-1.514l-47.099,17.994c-5.653-0.799-11.301-1.202-16.82-1.202     c-38.053,0-70.042,17.079-87.94,43.78c-13.46-1.174-16.008-9.987-16.282-11.149c-0.852-4.063-4.816-6.696-8.902-5.902     c-4.124,0.804-6.817,4.801-6.011,8.925C1.456,68.396,8.03,80.075,23.6,83.882c-4.956,11.342-7.667,23.904-7.667,37.282     c0,26.564,11.195,51.226,30.997,68.89c-9.853,10.457-9.668,26.98,0.561,37.206c5.044,5.047,11.755,7.827,18.892,7.827     c7.137,0,13.845-2.78,18.892-7.827l12.815-12.815c15.828,2.843,32.702,2.417,48.068-1.154l13.969,13.972     c5.047,5.044,11.758,7.824,18.892,7.824c7.134,0,13.842-2.78,18.892-7.827c10.411-10.416,10.411-27.365-0.003-37.784     l-2.747-2.744c8.357-8.273,15.062-17.994,19.734-28.618h6.079c12.587,0,22.826-10.241,22.826-22.826V107.04     C243.801,94.455,233.563,84.214,220.976,84.214z M228.584,135.278c0,4.195-3.414,7.609-7.609,7.609H209.77     c-3.183,0-6.029,1.978-7.134,4.963c-4.679,12.628-12.754,23.954-23.356,32.755c-1.646,1.367-2.643,3.366-2.742,5.504     s0.708,4.22,2.222,5.734l8.387,8.387c4.484,4.484,4.484,11.783,0.003,16.262c-2.171,2.174-5.06,3.371-8.131,3.371     c-3.071,0-5.963-1.197-8.134-3.368l-17.025-17.028c-1.446-1.446-3.388-2.229-5.379-2.229c-0.675,0-1.352,0.089-2.019,0.271     c-8.636,2.379-17.784,3.584-27.183,3.584c-7.505,0-14.933-0.789-22.08-2.343c-2.536-0.553-5.169,0.223-6.997,2.057     l-15.689,15.689c-2.171,2.171-5.06,3.368-8.134,3.368c-3.071,0-5.96-1.197-8.134-3.368c-4.484-4.487-4.484-11.781,0-16.265     l5.384-5.384c1.565-1.562,2.371-3.731,2.209-5.937c-0.16-2.206-1.276-4.233-3.051-5.549     c-20.109-14.933-31.641-37.601-31.641-62.2c0-45.57,37.888-79.935,88.132-79.935c5.387,0,10.933,0.444,16.483,1.321     c1.314,0.211,2.66,0.068,3.901-0.408l34.652-13.236L168.8,47.772c-0.936,3.206,0.327,6.65,3.117,8.486     c14.362,9.468,24.992,22.681,30.739,38.208c1.106,2.985,3.954,4.968,7.134,4.968h11.185c4.195,0,7.609,3.414,7.609,7.609V135.278     z" />
                                <circle cx="166.674" cy="99.388" r="10.568" />
                                <rect x="97.142" y="55.216" width="44.383" height="15.217" />
                              </g>
                            </g>
                          </g>
                        ) : <use xlinkHref={`/icons.svg#icon-${icon}`}></use>}

                      </svg>
                      <span className="font-display text-base font-medium">
                        {text}
                      </span>
                    </button>
                  </Tab>
                );
              })}
            </TabList>

            {(tabItem.length === 4) ? (<>
              <TabPanel>
                <div>
                  {/* <!-- Filter --> */}
                  <Tokens category={itemActive} setCategory={setItemActive} />
                </div>
              </TabPanel>
              <TabPanel>
                <div>
                  {/* <!-- Filter --> */}
                  <On_sale />
                </div>
              </TabPanel>
              <TabPanel>
                <div>
                  {/* <!-- Filter --> */}
                  <Collections category={itemActive} setCategory={setItemActive} />
                </div>
              </TabPanel>
              <TabPanel>
                <div>
                  <Activity_tab category={itemActive} setCategory={setItemActive} />
                </div>
              </TabPanel>
            </>) : (<>
              <TabPanel>
                <div>
                  {/* <!-- Filter --> */}
                  <On_sale />
                </div>
              </TabPanel>
              <TabPanel>
                <div>
                  {/* <!-- Filter --> */}
                  <Public_Tokens toFetchPublicKey={public_key} category={itemActive} setCategory={setItemActive} />
                </div>
              </TabPanel>
            </>)
            }
          </Tabs>

        </div>
      </section >
    </>
  );
};

export default User_items;
